import { ComponentRendering, PlaceholdersData } from '@sitecore-jss/sitecore-jss-nextjs';

export const getComponentProps = (
  placeholders: PlaceholdersData | undefined,
  componentName: string
): ComponentRendering | null => {
  return placeholders
    ? (Object.values(placeholders)
        .flat()
        .find((el: ComponentRendering) => el.componentName === componentName) as ComponentRendering)
    : null;
};
